<template>
  <div hidden>
    <div ref="tooltip" class="map-tooltip">
      <div ref="tooltipText" class="map-tooltip-text"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "centers-map-tooltip",
  methods: {
    /**
     * Hides the tooltip
     */
    hide() {
      this.$refs.tooltip.hidden = true;
    },
    showAt(x, y, centers) {
      const tooltip = this.$refs.tooltip;
      if (centers.length == 0) {
        tooltip.hidden = true;
        return;
      }
      tooltip.hidden = false;
      tooltip.style.top =
        y + window.scrollY + 20 / window.devicePixelRatio + "px";
      tooltip.style.left =
        x + window.scrollX + 20 / window.devicePixelRatio + "px";
      this.$refs.tooltipText.innerHTML = centers
        .map((x) => x.name)
        .join("<br/>");
    },
    showTextAtMarker(marker, text) {
      const tooltip = this.$refs.tooltip;
      tooltip.hidden = false;
      const bbox = marker.elem.getBoundingClientRect();
      tooltip.style.top = bbox.top + window.scrollY + "px";
      tooltip.style.left = bbox.left + window.scrollX + 25 + "px";
      this.$refs.tooltipText.innerHTML = text;
    },
    showAtMarker(marker) {
      this.showTextAtMarker(marker, marker.center.name);
    },
  },
  mounted() {
    this.$refs.tooltip.hidden = true;
  },
};
</script>

<style lang="scss" scoped>
.map-tooltip {
  user-select: none;
  pointer-events: none;
  position: absolute;
  border-radius: 10px;
  padding: 5px 15px;
  border: solid 1px var(--border-color);
  background-color: var(--main-bg-color);
  filter: drop-shadow(0px 0px 1px #00000040);
}

.map-tooltip-text {
  text-align: center;
}
</style>
